import React from 'react';

import { Box, Button } from '@mui/material';

import { useNavigate } from 'react-router';

function segmentSx({ isActive, tone, borderRadius }) {
  const activeBg = tone === 'draft' ? 'warning.main' : 'success.main';
  return {
    borderRadius,
    fontSize: '11px',
    lineHeight: '12px',
    padding: '4px 8px',
    fontWeight: 400,
    minWidth: 0,
    color: isActive ? 'background.paper' : 'text.secondary',
    bgcolor: isActive ? activeBg : 'action.hover',
    '&:hover': {
      bgcolor: isActive ? activeBg : 'action.selected',
      color: isActive ? 'background.paper' : 'text.primary',
    },
    '&.Mui-disabled': {
      color: isActive ? 'background.paper' : 'text.secondary',
      bgcolor: isActive ? activeBg : 'action.hover',
      opacity: 1,
    },
  };
}

function DraftProductionSwitch({ isDraft, hasPublishedVersion: _hasPublishedVersion, projectId }) {
  const navigate = useNavigate();
  const tone = isDraft ? 'draft' : 'production';

  return (
    <Box sx={{ display: 'inline-flex' }}>
      <Button
        size="small"
        disabled={isDraft}
        onClick={() => navigate(`/project/canvas/${projectId}`)}
        sx={segmentSx({ isActive: isDraft, tone, borderRadius: '6px 0 0 6px' })}
      >
        Draft
      </Button>
      <Button
        size="small"
        disabled={!isDraft}
        onClick={() => navigate(`/project/production/${projectId}`)}
        sx={segmentSx({ isActive: !isDraft, tone, borderRadius: '0 6px 6px 0' })}
      >
        Production
      </Button>
    </Box>
  );
}

export default DraftProductionSwitch;
